/**
 * Strips HTML from the given string
 * @param value The input string
 * @returns The string with all HTML tags stripped out
 */
export var stripHtml = function (value) { return value.replace(/<[^>]*>/gm, ''); };
